//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
	
	const recorderManager = uni.getRecorderManager();//录音
	const innerAudioContext = uni.createInnerAudioContext();//播放
	const mp3RecoderOptions = {
		format: 'mp3'
	}
	export default {
		name: 'jsfun-record',
		props: {
			voicePath: { //默认地址
				type: String,
				default: '' 
			},
			maxTime: { // 录音最大时长，单位秒
				type: Number,
				default: 60
			},
			minTime: { // 录音最大时长，单位毫秒
				type:Number ,
				default: 3
			},
		},		
		data() {
			return {				
				isShow:false,	
				frame: 50, // 执行绘画的频率，单位毫秒
				recordTime:0,//录音时长
				isshowyuan:false,//是否显示圆圈
				playing:0,//是否播放中
			}
		},
		computed: {
			showRecordTime() {
				var strs = "";
				var m = Math.floor(this.recordTime/60);
				if(m<10) strs = "0"+m;
				
				var s = this.recordTime%60;
				strs += (s<10) ? ":0"+s : ":"+s;
								
				return strs
			}
		},
		watch: {
			//这里需要监听默认值的改变，重新初始化
		  //   defaultArr(val) {
				// console.log(val);
				// this.initValue();
		  //   }
		},
		onLoad() {		
			var _this = this;
			//获取录音权限
			uni.authorize({
				scope: 'scope.record',
				success() {
				}
			})
			//初始化
			this.initValue();			
			
		},
		onReady() {
			var _this = this;
			//录音停止事件
				recorderManager.onStop(function (res) {
					uni.uploadFile({
						url: _this.$store.state.proxyUrl+'/weChat/file/upload', //仅为示例，非真实的接口地址
						filePath: res.tempFilePath,
						formData: {
							'tenantId': _this.$store.state.tenantId
						},
						name: 'files',
						success: (uploadFileRes) => {
							let url=JSON.parse(uploadFileRes.data).data[0].store
							let obj={
								mediaUrl:url,
								mediaLen:_this.recordTime
							}
							_this.$emit('okClick',obj)
						}
					})
				})
			
				// _this.voicePath = res.tempFilePath;
			//根据canvas 动态中心点				
			var query = uni.createSelectorQuery().in(this);
			query.select(".canvas").boundingClientRect()
			query.exec(function(res){
				//这里原来使用比例计算发现有误差，所以采用下边的中心点计算
				//_this.bili = res[0].width / 100;
				
				_this.tempw = res[0].width;//使用canvas的宽度计算中心点的位置
				_this.temph = res[0].height;
			})
			//根据中心图片的大小计算圆环的大小
			var query = uni.createSelectorQuery().in(this);
			query.select(".recording").boundingClientRect()
			query.exec(function(res){
				_this.tempw1 = res[0].width;//使用点按图形的宽度计算圆环的宽高
			})
		},
		methods: {
			moveHandle(){
				return false;
			},
			//组件数据初始化  进入时、关闭时调用初始化
			initValue(){
				
			},	
			//显示组件
			showPicker(){
				setTimeout(() => {
				  this.isShow = true;
				}, 100);				
			},
			//关闭组件
			closePicker(){				
				this.isShow = false;
				//点遮罩 点取消关闭说明用户不想修改，所以这里对数据进行初始化
				this.initValue(); 
				this.stopVoice();
			},					
			//点击确定
			okClick(){
				// var data = {},list = {},textStr = "",indexStr = "";
				let obj={
					mediaUrl:this.voicePath,
					mediaLen:this.recordTime
				}
				this.$emit('okClick',obj)
				
				//确定后更新默认初始值,这样再次进入默认初值就是最后选择的
				// this.defaultArr = textStr;
				//关闭
				this.closePicker();
			},
			
			
			start() {
				this.stopVoice();
				let obj={
					mediaUrl:'',
					mediaLen:0
				}
				this.$emit('okClick',obj)
				// this.voicePath = "";//音频地址				
				this.recordTime = 0;			
				//生成canvas对象
				this.canvasObj = uni.createCanvasContext('canvas');	
			},
			end() {
				let recordTime =  this.recordTime;
				clearTimeout(this.timeObj); //清除计时器
				clearInterval(this.drawObj); //清除画布动画	
				// this.recordTime = 0;//清除计时
				this.isshowyuan = false;//隐藏圆圈
				//清除canvas内容 方式一：不知道为啥 不起作用
				//this.canvasObj.clearRect(0,0,this.canvasObj.width,this.canvasObj.height);
				//清除canvas内容 方式二：填充canvas为白色
				this.canvasObj.setFillStyle('#fff')
				this.canvasObj.fillRect(0, 0, this.canvasObj.width,this.canvasObj.height)
				this.canvasObj.draw()
				 
				if(recordTime < this.minTime ){
					if (recordTime<=0) { 
						//==点击事件==;
						return false;
					}					
					//==小于5秒==;
					uni.showToast({
						title:"不能小于"+this.minTime+"秒,请重新录制",
						icon:"none"
					})
					return false;
				}
				recorderManager.stop();	
			},
			record() {
				let _this = this;
				_this.isshowyuan = true			
				// 开始录音
                recorderManager.start(mp3RecoderOptions);	
			
				_this.timeObj = setInterval(function() {	
					_this.recordTime ++;		
					if(_this.recordTime  == _this.maxTime) _this.end();
				},1000);
				
				//中心点坐标 这里如果直接除2发现位置有偏差，目前还没明白为什么要减1
				let pianyi = 0
				switch(uni.getSystemInfoSync().platform){
					case 'android': pianyi=0;break;
					case 'ios':pianyi=1;break;
					default:pianyi=1; break;
				}
				let centerX = _this.tempw/2 + pianyi;
				let centerY = _this.temph/2 + pianyi;
				let yuanhuanW = _this.tempw1/2+4;//圆环的半径  中间图片的宽度/2 + 4
				
				// 录音过程圆圈动画的背景园
				_this.canvasObj.beginPath();
				_this.canvasObj.setStrokeStyle("#fe3b54");
				_this.canvasObj.setGlobalAlpha(0.3)
				_this.canvasObj.setLineWidth(3);
				_this.canvasObj.arc(centerX,centerY, yuanhuanW , 0, 2 * Math.PI);				
				_this.canvasObj.stroke();
				_this.canvasObj.draw();
				
				// 录音过程圆圈动画
				let angle = -0.5;				
				_this.drawObj = setInterval(function() {
					_this.canvasObj.beginPath();
					_this.canvasObj.setStrokeStyle("#fe3b54");					
					_this.canvasObj.setGlobalAlpha(1)
					_this.canvasObj.setLineWidth(3);
					_this.canvasObj.arc(centerX,centerY, yuanhuanW , -0.5 * Math.PI, (angle += 2 / (_this.maxTime * 1000 / _this.frame)) * Math.PI, false);
					_this.canvasObj.stroke();
					_this.canvasObj.draw(true);
				}, _this.frame);
				
				
			},
			playVoice() {
				if (this.voicePath) {
					innerAudioContext.src = this.$getImg(this.voicePath);
					innerAudioContext.play();
					this.playing = 1;
				}
			},
			stopVoice() {
				innerAudioContext.stop();
				this.playing = 0;			
			}
		}
	}
